import { BehaviorSubject } from 'rxjs';
import { fetchWrapper } from '../utils/apiHandlers';
import { clientLogger } from '../utils/clientLogger';

const ISSERVER = typeof window === "undefined";
const user = !ISSERVER && JSON.parse(localStorage.getItem('user')||'{}')
// const user = !ISSERVER && JSON.parse(localStorage.getItem('user')||{})
const userSubject = new BehaviorSubject(user)

export const userContext = {
    user: userSubject.asObservable(),
    get userValue () { return userSubject.value },
    logout,
    login,
    register,
    registershopper,
    updateprofile,
};

function logout() {
    // remove user from local storage, publish null to user subscribers and redirect to login page
    localStorage.removeItem('user')
    userSubject.next({})
}

async function login(email:any, password:any) {
    return new Promise(async (resolve) =>{
        await fetchWrapper.post(`/api/authenticate/login`, { email, password }).then(async (user: any) =>{
            console.log(`user : ${JSON.stringify(user)}`)
            
            userSubject.next(user)
            localStorage.setItem('user', JSON.stringify(user))

            resolve(user)
        }).catch((error: any) =>{
                console.log(`Error: ${error}`)
                resolve(null)
            })
    })
}

async function register(email:any, verificationcode: any, password:any) {
    const body = {
        email: email,
        verificationcode: verificationcode,
        password: password
    }
    return new Promise(async (resolve) =>{
        await fetchWrapper.post("/api/authenticate/registeruser", body).then((res:any) => {
            console.log(`res ${JSON.stringify(res)}`);
            if(res.status==200){
                userSubject.next(res.user)
                localStorage.setItem('user', JSON.stringify(res.user))
                resolve(true)
            }else{
                resolve(false)
            }
          }).catch((error: any)=> {
            clientLogger("info", error)
            resolve(false)
          })
    })
}

// Ask Amigo shopper signup: no verification link, works immediately, and (like login) never
// navigates anywhere - the person stays right where they were (see chatsidebar.tsx).
async function registershopper(email:any, password:any, firstname?: any) {
    return new Promise(async (resolve) =>{
        await fetchWrapper.post("/api/authenticate/registershopper", { email, password, firstname }).then((res:any) => {
            if(res.status==200){
                userSubject.next(res)
                localStorage.setItem('user', JSON.stringify(res))
                resolve(res)
            }else{
                resolve(res)
            }
          }).catch((error: any)=> {
            clientLogger("info", error)
            resolve(null)
          })
    })
}

async function updateprofile(userid: any, firstname: any, lastname: any, phonenumber: any, websiteurl: any, address: any){
    const body = {
        userid: userid,
        firstname: firstname,
        lastname: lastname,
        phonenumber: phonenumber,
        websiteurl: websiteurl,
        address: address,
    }
    return new Promise(async (resolve) =>{
        await fetchWrapper.post("/api/authenticate/updateprofile", body).then((res:any) => {
            console.log(`res ${JSON.stringify(res)}`);
            if(res.status==200){
                userSubject.next(res)
                localStorage.setItem('user', JSON.stringify(res))
                resolve(true)
            }else{
                resolve(false)
            }
          }).catch((error)=> {
            console.log(`Error: ${error}`)
            resolve(false)
          })
    })
}

